import { interpolate } from "remotion";
/**
 * This function should be used instead of Remotion's interpolate. The main purpose
 * is to ensure that the input range is always increasing, either by
 * confirming that it will always increase (and using "ideal-range-always-increasing")
 * or by providing a safe, backup input range to use instead.
 */
export function safeInterpolate(input, inputRange, outputRange, options) {
    let usableInputRange = inputRange.ideal;
    if (inputRange.safe !== "ideal-range-always-increasing") {
        if (inputRange.safe.length !== inputRange.ideal.length) {
            console.error("Safe and ideal inputs ranges must have the same length");
        }
        if (!isArrayIncreasing(inputRange.safe)) {
            console.error(`Safe Input range ${inputRange.safe} is non-increasing.`);
        }
        // Check whether the input range is always increasing
        if (!isArrayIncreasing(inputRange.ideal)) {
            usableInputRange = inputRange.safe;
        }
    }
    return interpolate(input, usableInputRange, outputRange, options);
}
function isArrayIncreasing(arr) {
    for (let i = 1; i < arr.length; i++) {
        const current = arr[i];
        const previous = arr[i - 1];
        if (current === undefined || previous === undefined) {
            console.log("Array", arr);
            throw new Error(`Array contained an undefined value at index ${i} or ${i - 1}`);
        }
        if (current <= previous) {
            return false;
        }
    }
    return true;
}
/**
 * This function should be used on an argument passed to `interpolate` to ensure
 * that a frame range is "monotonically increasing". It should only be used in
 * cases where a short clip might cause a frame range to decrease. It should not
 * be used in other situations because it could hide a bug.
 */
export function guardIncreasingFrameRange(range, fallback) {
    const finalRange = [];
    let previousValue = undefined;
    for (const value of range) {
        if (previousValue === undefined) {
            finalRange.push(value);
            previousValue = value;
        }
        else {
            // the frame range is not increasing
            if (value <= previousValue) {
                // if there's a fallback, return it
                if (fallback) {
                    // we want to make sure the fallback is increasing too
                    return guardIncreasingFrameRange(fallback);
                }
                const thisValue = previousValue + 1;
                finalRange.push(thisValue);
                previousValue = thisValue;
            }
            else {
                finalRange.push(value);
                previousValue = value;
            }
        }
    }
    return finalRange;
}
